export default __webpack_public_path__ + "static/media/drop-down-arrow.b2da7b85.svg";